import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import HeroBanner from '../components/HeroBanner';
import { FiPhone, FiSend } from 'react-icons/fi';
import { MdShoppingCart } from 'react-icons/md';
import { FaBars } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';
import { IoIosSearch } from 'react-icons/io';
import { FaCalendarAlt, FaUser, FaRegCommentDots, FaUserCircle } from 'react-icons/fa';

const BlogSingle: React.FC = () => {
  useEffect(() => {
    // Example: Scroll to top on mount
    window.scrollTo(0, 0);
    const script = document.createElement('script');
    script.src = '/js/main.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);


  return (
    <div className="goto-here">
      {/* Top Bar */}
      <div className="py-1 bg-primary">
        <div className="container">
          <div className="row no-gutters d-flex align-items-start align-items-center px-md-0">
            <div className="col-lg-12 d-block">
              <div className="row d-flex">
                <div className="col-md pr-4 d-flex topper align-items-center">
                  <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiPhone size={12} color="white" /></div>
                  <span className="text">+91 9148761750</span>
                </div>
                <div className="col-md pr-4 d-flex topper align-items-center">
                  <div className="icon mr-2 d-flex justify-content-center align-items-center"><FiSend size={12} color="white" /></div>
                  <span className="text">care@fhome.shop</span>
                </div>
                <div className="col-md-5 pr-4 d-flex topper align-items-center text-lg-right">
                  <span className="text">3-5 Business days delivery &amp; Free Returns</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%" ,width: "80px"}}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">Shop</a>
                  <a className="dropdown-item" href="/wishlist">Wishlist</a>
                  <a className="dropdown-item" href="/product-single">Single Product</a>
                  <a className="dropdown-item" href="/cart">Cart</a>
                  <a className="dropdown-item" href="/checkout">Checkout</a>
                   <a className="dropdown-item" href="/my-orders">Orders</a>
                </div>
              </li>
              <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
              <li className="nav-item active"><a href="/blog" className="nav-link">Blog</a></li>
              <li className="nav-item"><a href="/contact" className="nav-link">Contact</a></li>
              <li className="nav-item cta cta-colored"><a href="/cart" className="nav-link">
                <span><MdShoppingCart size={18} /></span> [0]
              </a></li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <HeroBanner image="images/fhome-ingredients-platter.jpg">
        <div className="row no-gutters slider-text align-items-center justify-content-center">
          <div className="col-md-9 ftco-animate text-center">
            <p className="breadcrumbs"><span className="mr-2"><a href="/">Home</a></span> <span>Blog</span></p>
            <h1 className="mb-0 bread">Blog</h1>
          </div>
        </div>
      </HeroBanner>
      {/* Blog Single Section */}
      <section className="ftco-section ftco-degree-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 ftco-animate">
              <h2 className="mb-3">F.home - Fresh From Home</h2>
              <p>F.home - Fresh From Home was founded with a simple mission: to bring pure, authentic, and naturally produced food directly from farms to every home.</p>
              <p>
                <img src="images/image_1.jpg" alt="" className="img-fluid" />
              </p>
              <p>We carefully source grains, pulses, native rice varieties, and farm-fresh produce from our farms and local farm communities that support farmers.</p>
              <h2 className="mb-3 mt-5">Our Farm to Home Promise</h2>
              <p>Along with fresh produce, we offer traditionally prepared foods such as wood-pressed oils, homemade cow ghee, handcrafted masalas, and other wholesome essentials.</p>
              <p>
                <img src="images/image_2.jpg" alt="" className="img-fluid" />
              </p>
              <p>At F.home, quality is our highest priority. Every product is prepared and packed with care, with no artificial colours, no preservatives, and no additives.</p>
              <p>Our goal is to preserve the taste and nutrition of traditional foods while supporting local farms and farm societies through direct sourcing and convenient home delivery.</p>
              <p>Our motto, "Farm to Home," reflects our commitment to providing fresh, safe, and nutritious food for every family.</p>
              <p>Every F.home product is a promise of purity, authenticity, and trust.</p>
              <div className="tag-widget post-tag-container mb-5 mt-5">
                <div className="tagcloud">
                  <a href="#" className="tag-cloud-link">Farm Fresh</a>
                  <a href="#" className="tag-cloud-link">Native Rice</a>
                  <a href="#" className="tag-cloud-link">Wood-Pressed Oils</a>
                  <a href="#" className="tag-cloud-link">Homemade Foods</a>
                </div>
              </div>
              <div className="about-author d-flex p-4 bg-light">
                <div className="bio align-self-md-center mr-4">
                  <img src="images/person_1.jpg" alt="Image placeholder" className="img-fluid mb-4" />
                </div>
                <div className="desc align-self-md-center">
                  <h3>F.home Editorial Team</h3>
                  <p>We share stories from farms, traditional kitchens, and local communities to help every family choose cleaner, safer, and more nourishing foods.</p>
                </div>
              </div>
              <div className="pt-5 mt-5">
                <h3 className="mb-5">6 Comments</h3>
                <ul className="comment-list">
                  {/* Nested comments structure, can be refactored to a component if needed */}
                  <li className="comment">
                    <div className="vcard bio">
                      <FaUserCircle size={56} color="#9aa0a6" />
                    </div>
                    <div className="comment-body">
                      <h3>Arjun Kumar</h3>
                      <div className="meta">June 27, 2018 at 2:21pm</div>
                      <p>The quality is consistently excellent. The products taste fresh and feel truly homemade.</p>
                      <p><a href="#" className="reply">Reply</a></p>
                    </div>
                    <ul className="children">
                      <li className="comment">
                        <div className="vcard bio">
                          <FaUserCircle size={56} color="#9aa0a6" />
                        </div>
                        <div className="comment-body">
                          <h3>Priya Sharma</h3>
                          <div className="meta">June 27, 2018 at 2:21pm</div>
                          <p>Delivery was on time and packaging was very neat. Happy to support a farm-first brand.</p>
                          <p><a href="#" className="reply">Reply</a></p>
                        </div>
                        <ul className="children">
                          <li className="comment">
                            <div className="vcard bio">
                              <FaUserCircle size={56} color="#9aa0a6" />
                            </div>
                            <div className="comment-body">
                              <h3>Ramesh Iyer</h3>
                              <div className="meta">June 27, 2018 at 2:21pm</div>
                              <p>The wood-pressed oils and masalas have a real traditional aroma. Highly recommended.</p>
                              <p><a href="#" className="reply">Reply</a></p>
                            </div>
                            <ul className="children">
                              <li className="comment">
                                <div className="vcard bio">
                                  <FaUserCircle size={56} color="#9aa0a6" />
                                </div>
                                <div className="comment-body">
                                  <h3>Neha Patel</h3>
                                  <div className="meta">June 27, 2018 at 2:21pm</div>
                                  <p>Great initiative for supporting local farmers while giving families clean, healthy food.</p>
                                  <p><a href="#" className="reply">Reply</a></p>
                                </div>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li className="comment">
                    <div className="vcard bio">
                      <FaUserCircle size={56} color="#9aa0a6" />
                    </div>
                    <div className="comment-body">
                      <h3>Suresh Nair</h3>
                      <div className="meta">June 27, 2018 at 2:21pm</div>
                      <p>I appreciate the no additives approach. It gives me confidence when buying for my kids.</p>
                      <p><a href="#" className="reply">Reply</a></p>
                    </div>
                  </li>
                </ul>
                {/* END comment-list */}
                <div className="comment-form-wrap pt-5">
                  <h3 className="mb-5">Leave a comment</h3>
                  <form action="#" className="p-5 bg-light">
                    <div className="form-group">
                      <label htmlFor="name">Name *</label>
                      <input type="text" className="form-control" id="name" />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email">Email *</label>
                      <input type="email" className="form-control" id="email" />
                    </div>
                    <div className="form-group">
                      <label htmlFor="website">Website</label>
                      <input type="url" className="form-control" id="website" />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">Message</label>
                      <textarea name="" id="message" cols={30} rows={10} className="form-control"></textarea>
                    </div>
                    <div className="form-group">
                      <input type="submit" value="Post Comment" className="btn py-3 px-4 btn-primary" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Sidebar */}
            <div className="col-lg-4 sidebar ftco-animate">
              <div className="sidebar-box">
                <form action="#" className="search-form">
                  <div className="form-group position-relative">
                    <span className="search-icon">
                      <IoIosSearch size={18} color="#888" />
                    </span>
                    <input type="text" className="form-control search-input" placeholder="Search..." />
                  </div>
                </form>
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Categories</h3>
                <ul className="categories">
                  <li><a href="#">Vegetables <span>(12)</span></a></li>
                  <li><a href="#">Fruits <span>(22)</span></a></li>
                  <li><a href="#">Juice <span>(37)</span></a></li>
                  <li><a href="#">Dries <span>(42)</span></a></li>
                </ul>
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Recent Blog</h3>
                {[1, 2, 3].map(i => (
                  <div className="block-21 mb-4 d-flex" key={i}>
                    <a className="blog-img mr-4" style={{ backgroundImage: `url('images/image_${i}.jpg')` }}></a>
                    <div className="text">
                      <h3 className="heading-1"><a href="#">F.home - Fresh From Home</a></h3>
                      <div className="meta d-flex align-items-center text-muted" style={{ fontSize: '14px' }}>
                        <div className="mr-3 d-flex align-items-center">
                          <FaCalendarAlt style={{ marginRight: '5px' }} />
                          April 09, 2019
                        </div>
                        <div className="mr-3 d-flex align-items-center">
                          <FaUser style={{ marginRight: '5px' }} />
                          Admin
                        </div>
                        <div className="d-flex align-items-center">
                          <FaRegCommentDots style={{ marginRight: '5px' }} />
                          19
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Tag Cloud</h3>
                <div className="tagcloud">
                  {['fruits', 'tomatoe', 'mango', 'apple', 'carrots', 'orange', 'pepper', 'eggplant'].map(tag => (
                    <a href="#" className="tag-cloud-link" key={tag}>{tag}</a>
                  ))}
                </div>
              </div>
              <div className="sidebar-box ftco-animate">
                <h3 className="heading">Paragraph</h3>
                <p>Farm to Home is more than a motto at F.home. It is our daily commitment to purity, authenticity, and nutrition for every household.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
      <a
        href="https://wa.me/919148761750"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
      </a>
    </div>
  );
};

export default BlogSingle;

